module.exports = __webpack_public_path__ + "img/help-user3.6146fc5b.png";